import { Controller } from '@hotwired/stimulus'

export default class RiskCategoryFilterController extends Controller {
  static targets = ['typeCheckbox', 'categoryItem']

  declare readonly typeCheckboxTargets: HTMLInputElement[]
  declare readonly categoryItemTargets: HTMLElement[]

  connect (): void {
    this.filterCategories()
  }

  filterCategories (): void {
    const selectedTypes = this.typeCheckboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)

    this.categoryItemTargets.forEach((item: HTMLElement) => {
      const typeName = item.getAttribute('data-risk-type-name') ?? ''

      if (selectedTypes.length === 0 || selectedTypes.includes(typeName)) {
        item.classList.remove('hidden')
      } else {
        const checkbox = item.querySelector<HTMLInputElement>('input[type="checkbox"]')
        if (checkbox?.checked === true) {
          checkbox.checked = false
          checkbox.dispatchEvent(new Event('change', { bubbles: true }))
        }
        item.classList.add('hidden')
      }
    })
  }
}
